/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vagrant Box Registry
 * API for managing Vagrant boxes.
 *
 * The version of the OpenAPI document: 2022-09-30
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudVagrant20220930CreateVersionResponseFromJSON, HashicorpCloudVagrant20220930ListVersionsResponseFromJSON, HashicorpCloudVagrant20220930ReadVersionResponseFromJSON, HashicorpCloudVagrant20220930UpdateVersionResponseFromJSON, InlineObject2ToJSON, InlineObject3ToJSON, } from '../models';
/**
 *
 */
export class VersionServiceApi extends runtime.BaseAPI {
    /**
     * CreateVersion creates a new Box Version.
     */
    async createVersionRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling createVersion.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling createVersion.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject2ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930CreateVersionResponseFromJSON(jsonValue));
    }
    /**
     * CreateVersion creates a new Box Version.
     */
    async createVersion(registry, box, body) {
        const response = await this.createVersionRaw({ registry: registry, box: box, body: body });
        return await response.value();
    }
    /**
     * Deleting a Box Version removes all its Providers as well. This operation cannot be undone.
     * DeleteVersion deletes a Box Version.
     */
    async deleteVersionRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling deleteVersion.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling deleteVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling deleteVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Deleting a Box Version removes all its Providers as well. This operation cannot be undone.
     * DeleteVersion deletes a Box Version.
     */
    async deleteVersion(registry, box, version) {
        const response = await this.deleteVersionRaw({ registry: registry, box: box, version: version });
        return await response.value();
    }
    /**
     * ListVersion lists all of the Versions within a particular Box.
     */
    async listVersionsRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling listVersions.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling listVersions.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930ListVersionsResponseFromJSON(jsonValue));
    }
    /**
     * ListVersion lists all of the Versions within a particular Box.
     */
    async listVersions(registry, box, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listVersionsRaw({ registry: registry, box: box, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * ReadVersion reads a Box Version.
     */
    async readVersionRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling readVersion.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling readVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling readVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930ReadVersionResponseFromJSON(jsonValue));
    }
    /**
     * ReadVersion reads a Box Version.
     */
    async readVersion(registry, box, version) {
        const response = await this.readVersionRaw({ registry: registry, box: box, version: version });
        return await response.value();
    }
    /**
     * Release releases the specified Version. The Version must not already be released.
     */
    async releaseVersionRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling releaseVersion.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling releaseVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling releaseVersion.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling releaseVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/release`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Release releases the specified Version. The Version must not already be released.
     */
    async releaseVersion(registry, box, version, body) {
        const response = await this.releaseVersionRaw({ registry: registry, box: box, version: version, body: body });
        return await response.value();
    }
    /**
     * Revoke revokes the specified Version. The Version must be actively released.
     */
    async revokeVersionRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling revokeVersion.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling revokeVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling revokeVersion.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling revokeVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/revoke`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Revoke revokes the specified Version. The Version must be actively released.
     */
    async revokeVersion(registry, box, version, body) {
        const response = await this.revokeVersionRaw({ registry: registry, box: box, version: version, body: body });
        return await response.value();
    }
    /**
     * UpdateVersion updates a Box Version.
     */
    async updateVersionRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling updateVersion.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling updateVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling updateVersion.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject3ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930UpdateVersionResponseFromJSON(jsonValue));
    }
    /**
     * UpdateVersion updates a Box Version.
     */
    async updateVersion(registry, box, version, body) {
        const response = await this.updateVersionRaw({ registry: registry, box: box, version: version, body: body });
        return await response.value();
    }
}
